import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

function useResetPasswordSelection() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [updated, setUpdated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);

  const [minimumChar, setMinChar] = useState("");

  const params: { token?: string; ip?: string } = useParams();

  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get("/api/reset", {
          params: {
            resetPasswordToken: params.token,
          },
        });
        if (response.data.message === "password reset link a-ok") {
          setEmail(response.data.username);
          setUpdated(false);
          setIsLoading(false);
          setError(false);
        }
      } catch (error: any) {
        console.log(error.response.data);
        setUpdated(false);
        setIsLoading(false);
        setError(true);
      }
    })();
  }, [params.token]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    var value = event.target.value;
    var name = event.target.name;
    name === "password" && setPassword(value);
  };

  const updatePassword = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (password.length < 6) {
      return setMinChar("Password must be at least 6 characters");
    }

    try {
      const response = await axios.put("/api/updatePasswordViaEmail", {
        email,
        password,
        resetPasswordToken: params.token,
        ipToRemove: params.ip || null,
      });

      if (response.data.message === "password updated") {
        setUpdated(true);
        setError(false);
      } else {
        setUpdated(false);
        setError(true);
      }
    } catch (error: any) {
      console.log(error.response.data);
      setUpdated(false);
      setError(true);
    }
  };

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const handleMouseDownPassword = (event: React.MouseEvent<any>) =>
    event.preventDefault();

  return {
    handleMouseDownPassword,
    handleClickShowPassword,
    showPassword,
    updatePassword,
    handleChange,
    minimumChar,
    error,
    isLoading,
    updated,
    password,
  };
}

export default useResetPasswordSelection;
